

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class CoreItemList_ManagedObject

class CoreItemList_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }
    // Relationship: conceptItem
    set conceptItem(value:ConceptItem) {
        this.setValueForKey(value, 'conceptItem');
    }
    get conceptItem():ConceptItem {
        return this.valueForKey('conceptItem') as ConceptItem;
    }
    // Relationship: product
    set product(value:Product) {
        this.setValueForKey(value, 'product');
    }
    get product():Product {
        return this.valueForKey('product') as Product;
    }
}
